var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',{staticClass:"currency-input"},[_vm._v(_vm._s(_vm.getCurrency)+_vm._s(_vm.total))]),(_vm.conversionPostfix)?_c('span',{staticClass:"font-weight-bold",staticStyle:{"color":"red"}},[_vm._v(" ("+_vm._s(_vm.conversionPostfix)+") ")]):_vm._e(),(_vm.type)?_c('span',[_vm._v("/ "+_vm._s(_vm.type))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }